import Vue from 'vue'
import Router from 'vue-router'
import { Toast } from 'vant'
import {login} from '@/api'
import {getUrlParam} from '@/common/utils'

Vue.use(Router)

const router = function (routes) {
  /* eslint-disable no-new */
  const route = new Router({
    mode: 'history',
    routes
  })
  route.beforeEach((to, from, next) => {
    if (to.meta.title) {
      document.title = to.meta.title
    }
    // let code = getUrlParam('code')
    let code = ''
    let sessionCode = window.sessionStorage.getItem('code')
    if (sessionCode) {
      code = sessionCode
    } else {
      code = getUrlParam('code')
    }
    if (!code && !sessionCode) { // 网页授权
      // let url = 'http://ycyt-mobile-test.999haoche.com:8309/#' + to.path
      const appid = 'ww99192c1e2a31dbeb'
      let url = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + appid + '&redirect_uri=' + encodeURIComponent(location.href) + '&response_type=code&scope=snsapi_base#wechat_redirect'
      window.location.replace(url)
    } else {
      const token = window.sessionStorage.getItem('token')
      if (!token) {
        window.sessionStorage.setItem('code', code)
        login({code: window.sessionStorage.getItem('code')}).then(res => {
          window.sessionStorage.setItem('token', res.data.token)
          next()
          // location.reload()
        }).catch(err => {
          if (err.code !== '-101') {
            Toast.fail(err.msg)
          }
        })
      } else {
        next()
      }
    }
  })
  // route.afterEach(to => {
  //   window.scrollTo(0, 0)
  // })
  return route
}

export default router



// WEBPACK FOOTER //
// ./src/assets/js/router.js